import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Paragraph, Title } from 'ui-library';
import './ChangeWithdrawalPlan.css';

interface ChangeWithdrawalPlanProps {
    bankIBan: string;
    dfsClientId: string;
    portfolioId: string;
    ongoingPlan: boolean;
    hasAccessToChangeStrategy: boolean;
    hasAccessToChangeWithdrawal: boolean;
}

const ChangeWithdrawalPlan = ({
    bankIBan,
    dfsClientId,
    portfolioId,
    ongoingPlan,
    hasAccessToChangeStrategy,
    hasAccessToChangeWithdrawal,
} : ChangeWithdrawalPlanProps) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const handleChangeWithdrawalPlan = () => {
        sessionStorage.removeItem('advisory--withdrawalData');
        navigate(`/client/${dfsClientId}/portfolios/${portfolioId}/change-withdrawal/withdrawal-plan`);
    };

    return (
        <div className="change-withdrawal-plan mt-40">
            {!bankIBan && (
                <>
                    <Title type={2} className="font-normal mb-16">
                        {t('portfolio.createNewPortfolio.withdrawalPlan')}
                    </Title>
                    <Paragraph>
                        {t('portfolioDetail.strategy.withdrawalOption.noWithdrawalSetup')}
                    </Paragraph>
                </>
            )}

            {hasAccessToChangeWithdrawal && (
                <div className="button-group mt-16">
                    <Button
                        data-cy="changePlanBtn"
                        disabled={ongoingPlan || !hasAccessToChangeStrategy}
                        onClick={handleChangeWithdrawalPlan}
                    >
                        {bankIBan ? (
                            <>
                                {t('portfolioDetail.strategy.withdrawalOption.button.manageWithdrawalPlan')}
                            </>
                        ) : (
                            <>
                                {t('portfolioDetail.strategy.withdrawalOption.button.setupWithdrawalPlan')}
                            </>
                        )}

                    </Button>
                </div>
            )}
        </div>
    );
};

export default ChangeWithdrawalPlan;
